import { from, Observable, Subscriber } from "rxjs";
import { WebApiActionGet, WebApiActionPost, WebApiActionPut, WebApiActionDelete, QueryParams, WebApiItems } from "components/ajax/WebApi";
import rootUrl from "./url";
import { ValidatorFieldDef } from "components/validators";
import { RxFormFieldDef } from "components/rx-form";
import KeyValuePair from "components/utils/KeyValuePair";
import FileUpload, { FileUploadInfo } from "components/ajax/FileUpload";

const baseUrl = rootUrl + "api/forms";

export interface FileInfo {
    fileId?: number;
    name: string;
}

export interface Selection {
    type: 'checkbox' | 'combobox';
    items: KeyValuePair<number | string, string>[];
    min?: number;
    max?: number;
}


export interface SpecFile {
    min?: number;
    max?: number;
}

export interface SpecField extends RxFormFieldDef {
    type: 'text' | 'file' | 'selection';
    name: string;
    label: string;
    description?: string;
    file?: SpecFile;
    selection?: Selection;
}

export interface Specification {
    cisloDivize: number;
    fields: SpecField[];
}


export interface RespField {
    name: string;
    value?: any;
    values?: Array<any>;
}

export interface Response {
    fields: RespField[];
}

export interface FormSpecification {
    id: number;
    name: string;
    openFrom: Date;
    openTo: Date;
    specification: Specification;
}

export interface FormDecorated extends FormSpecification {
    completed: boolean;
    modified?: Date;
}

export interface FormResponse {
    specificationId: number;
    memberId: number;
    response: any;
    modified?: Date;
    completed: boolean;
    files: FormResponseFile[];
}

export interface FormResponseFile {
    specificationId: number;
    memberId: number;
    fileId: number;
    fileName: string;
    item: string;
}


export const apiGetSpecifications = function (): WebApiActionGet<FormSpecification[]> {
    return new WebApiActionGet<FormSpecification[]>(baseUrl);
}



export const apiGetSpecificationsDecoratedForMember = function (memberIdt: string): WebApiActionGet<FormDecorated[]> {
    return new WebApiActionGet<FormDecorated[]>(baseUrl + `/decorated/${memberIdt}`);
}

export const apiGetSpecification = function (specificationId: string, memberIdt: string): WebApiActionGet<FormSpecification> {
    return new WebApiActionGet<FormSpecification>(baseUrl + `/${specificationId}/${memberIdt}`);
}

export const apiGetResponse = function (specificationId: number, memberIdt: number): WebApiActionGet<FormResponse> {
    return new WebApiActionGet<FormResponse>(baseUrl + `/${specificationId}/response/${memberIdt}`);
}

export const apiPutResponse = function (specificationId: string, memberIdt: string): WebApiActionPut<FormResponse, FormResponse> {
    return new WebApiActionPut<FormResponse, FormResponse>(baseUrl + `/${specificationId}/response/${memberIdt}`);
}

export const apiPostFileUrl = function (specificationId: number, memberIdt: number) {
    return baseUrl + `/${specificationId}/response/${memberIdt}/files`;
}

export const apiGetResultsUrl = function (specificationId: number, format: string = "XLSX") {
    return baseUrl + `/${specificationId}/results?format=${format}`;
}

export const apiGetResultsFilesUrl = function (specificationId: number) {
    return baseUrl + `/${specificationId}/results/files`;
}

